import { Baseline, BaselineLite, BaselineValue, BaselineValueLite, VisionStep } from "@wizeoo/akm-message-lib";
import { WizConstants } from "../../model/constants";
import { EM_ACTION } from "../../model/enums";
import { Model } from "../../model/model";
import { DataLoadObj } from "../../vo/workingdata/dataload-obj";
import { BaselineEngine } from "./baseline.engine";

export class LoadDataService {

    // Pagination : nombre de baselines récupérées par appel au data.do
    public static CHUNK_SIZE: number = 50000;

    protected _model: Model = null;
    constructor(model: Model) {
        this._model = model;
    }

    /** définition du nombre d'appels nécessaire pour un pool */
    public getNumSegments(numResults: number): number {
        return Math.ceil(numResults / LoadDataService.CHUNK_SIZE);
    }

    /**
     * construction de la clé unique pour un FEI
     * @param vs le visionStep, va porter Domaine, Bu, vision, level
     * @param scenario le scénario
     * @returns la clé unique locale
     */
    public getFeiLocalKey(vs: VisionStep, scenario: string): string {
        const result: string = [vs.domain, vs.businessUnitCode, vs.visionCode, vs.level, scenario].join(WizConstants.KEY_SEPARATOR);
        return result;
    }


    public feedMapDataload(dlo: DataLoadObj) {
        // inscription dans la map
        if (!this._model.dataMap.has(dlo.visionStep.visionCode)) {
            this._model.dataMap.set(dlo.visionStep.visionCode, new Map());
        }
        if (!this._model.dataMap.get(dlo.visionStep.visionCode).has(dlo.visionStep.level)) {
            this._model.dataMap.get(dlo.visionStep.visionCode).set(dlo.visionStep.level, new Map());
        }
        this._model.dataMap.get(dlo.visionStep.visionCode).get(dlo.visionStep.level).set(dlo.scenario, dlo);
    }

    /**
       * retourne le dataLoad pour le couple level#scen correspondant
       * @param level 
       * @param scenario 
       * @returns 
       */
    public getDataloadByKey(visionCode: string, level: number, scenario: string): DataLoadObj {
        let dlo: DataLoadObj = this._model.dataMap.get(visionCode)?.get(level)?.get(scenario) || null;
        return dlo;
    }

    /** liste les dlos de façon unique */
    public getAllDataloads(visionCode: string, filterFn?: (dlo: DataLoadObj) => boolean): DataLoadObj[] {
        let res: DataLoadObj[] = [];
        [...this._model.dataMap.get(visionCode).keys()].forEach((level: number) => {
            [...this._model.dataMap.get(visionCode).get(level).values()].forEach((dlo: DataLoadObj) => {
                // Si on ne filtre pas ou si le statut est un statut chargé ou complet
                if (!filterFn || filterFn(dlo))
                    res.push(dlo);
            });
        })
        return res;
    }

    /**
     * Merge les baselines remotes dans les baselines locales
     * 
     * @param dataLoad l'objet de chargement des données
     */
    public mergeBaselines(dataLoad: DataLoadObj) {
        if (!dataLoad.localBaselines) { // attention à l'init...
            dataLoad.localBaselines = {};
        }

        // gestion des suppressions
        if (dataLoad.deletedBaselines?.size > 0) {
            let bl: Baseline = null; // la Baseline en cache local, qu'on va buter
            [...dataLoad.deletedBaselines.keys()].forEach((key: string) => {
                bl = dataLoad.localBaselines[key];
                if (!!bl) {
                    bl.operation = EM_ACTION.DELETE;
                    dataLoad.toDieBaseline.set(bl.key, bl); // pour synchro du cache local
                    delete dataLoad.localBaselines[key]; // suppression dans le dataload
                }
            });
        }

        // gestion des créations et updates sur les baselines
        // on écrase avec les données fraîches (mode sync)
        if (!!dataLoad.remoteBaselines) {
            let bl: Baseline = null;
            Object.values(dataLoad.remoteBaselines).forEach((blite: BaselineLite) => {
                bl = dataLoad.localBaselines[blite.key];
                if (!!bl) {
                    bl.revisionNumber = blite.rn;
                    bl.version = blite.ver;
                    bl.fkeyjson = blite.fkey;
                    bl.operation = EM_ACTION.UPDATE;
                } else {
                    bl = BaselineEngine.baselineLiteToBaseline(blite);
                    bl.operation = EM_ACTION.CREATE;
                }

                dataLoad.toPersistBaseline.set(bl.key, bl); // pour persistence en cache local
                dataLoad.localBaselines[bl.key] = bl; // et alimentation du jeu du dataload
            })
        }

        // gestion des créations et updates sur les baselineValues
        if (!!dataLoad.remoteBaselineValues) {

            let valueKey: string; // la clé unique de la BLV, meas#mode
            let bl: Baseline = null;
            let blv: BaselineValue;
            dataLoad.remoteBaselineValues.forEach((blvLite: BaselineValueLite) => {

                bl = dataLoad.localBaselines[blvLite?.key];
                if (!!bl) {
                    valueKey = blvLite.m + WizConstants.CONTEXT_SEPARATOR + blvLite.f; // pas alimenté sur les lites...
                    if (!!bl.values && !!bl.values[valueKey]) { // existe, update
                        blv = bl.values[valueKey];
                        blv.valor = blvLite.val;
                        blv.version = blvLite.ver;
                        blv.revisionNumber = blvLite.rn;
                        blv.operation = EM_ACTION.UPDATE;
                    } else { // create
                        if (!bl.values) {
                            bl.values = {};
                        }
                        blv = BaselineEngine.baselineValueLiteToBaselineValue(bl, blvLite);
                        blv.operation = EM_ACTION.CREATE;
                        bl.values[blv.mkey] = blv; // ajout dans la BL du dataload
                    }

                    dataLoad.toPersistBaseline.set(bl.key, bl); // pour persistence en cache local

                } else { // anomalie : la bl n'existe pas ?
                    console.log('orphan blv', blv, dataLoad.localBaselines);
                }
            });
        }
    }
}